// The two palettes the app can run in. A preset (theme-presets.js) layers over
// whichever mode it declares, and REACT_APP_THEME_* variables layer over both.
//
// Keep the two in step: every token present in one must be present in the other,
// or a mode switch leaves a token undefined. There is a test for that below the
// palettes, run from theme.js in development.

// The palette the site shipped with.
export const dark = {
  primary: '#03a9f4',
  primaryLight: '#67daff',
  primaryDark: '#0288d1',
  onPrimary: '#fff',
  accent: '#ffcc00',

  surface: '#303030',
  surfaceRaised: '#424242',
  surfaceSunken: '#2b2b2b',
  surfaceAccent: '#3a3a3a',
  surfaceMuted: '#3d3636',
  surfaceHover: 'rgb(86 86 86)',
  surfaceSelected: '#175f80',
  surfaceLight: '#ccc',
  surfaceInfo: '#0074d9',
  surfaceContrast: '#fff',
  surfaceInverse: '#161616',

  border: '#5a5858',
  borderMuted: '#6e6e6e',
  borderStrong: '#a6a4a4',

  textPrimary: '#fff',
  textMuted: '#a6a4a4',
  onScrim: '#fff',
  link: '#90caf9',

  danger: '#d43737',
  dangerMuted: '#bf4747',
  dangerStrong: '#d32f2f',
  dangerBright: '#f44336',
  success: '#4caf50',
  successLight: '#81c784',

  chart: {
    one: '#00A9E9',
    two: '#A900E9',
    three: '#00E9A9',
    four: '#E9A900',
  },
};

// A neutral light palette, used when no light preset is selected. It keeps the
// same brand blue so the toggle reads as a light/dark switch rather than a
// rebrand; surfaces and type invert, and status colours darken to stay legible.
export const light = {
  primary: '#0277bd',
  primaryLight: '#58a5f0',
  primaryDark: '#004c8c',
  onPrimary: '#fff',
  accent: '#8a6d00',

  surface: '#f4f5f7',
  surfaceRaised: '#ffffff',
  surfaceSunken: '#e9ebef',
  surfaceAccent: '#f0f1f4',
  surfaceMuted: '#e4e6ea',
  surfaceHover: 'rgb(226 229 234)',
  surfaceSelected: '#cfe4f5',
  surfaceLight: '#e4e6ea',
  surfaceInfo: '#0277bd',
  surfaceContrast: '#ffffff',
  surfaceInverse: '#1f2023',

  border: '#d3d6db',
  borderMuted: '#e4e6ea',
  borderStrong: '#9aa0a8',

  textPrimary: '#1f2023',
  textMuted: '#5f6670',
  // Scrims are dark in either mode, so content on them stays light.
  onScrim: '#fff',
  link: '#0b5fa5',

  danger: '#c62828',
  dangerMuted: '#a33227',
  dangerStrong: '#b71c1c',
  dangerBright: '#e53935',
  success: '#2e7d32',
  successLight: '#43a047',

  chart: {
    one: '#0277bd',
    two: '#7b3f9d',
    three: '#00796b',
    four: '#b26a00',
  },
};

export const basePalettes = { dark, light };

export default basePalettes;
